export default "__VITE_ASSET__C973RBlx__"